import { clsx, } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

export function firstNonEmpty(...values) {
  for (const v of values) {
    if (v) return v;
  }
  return values[values.length - 1] || '';
}

/**
 * Humanize snake_case / SCREAMING_SNAKE strings for display.
 * `single_choice` → `Single choice`. Preserves accents and multi-word input.
 */
export function prettifyTag(value) {
  if (!value) return '';
  const s = String(value).replaceAll('_', ' ').trim().toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any